// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"9cc6d6b1","70":"32fef241","249":"c7bcb34a","284":"8f963dbc","388":"e717c532","453":"f3d66190","521":"9f197ec8","543":"f157e480","704":"b67ae1d3","705":"d881891d","761":"0ad6b7ba","912":"8c4d4684","921":"a81de450","975":"59662fc5"}[chunkId] + ".chunk.js";
};